export enum InvoiceMethodEnum {
  ChangeInvoiceStatus = 'changeInvoiceStatus',
  RevertInvoiceToManual = 'revertInvoiceToManual',
  DeleteInvoiceCustomer = 'deleteInvoiceCustomer',
  GetPendingInvoiceByInvoiceID = 'getPendingInvoiceByInvoiceID',
}
